import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'bau365-shell-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() isLoggedIn = false;
  @Input() showMobileBottomBar: boolean | undefined | null;

  @Output() burgerMenuToggle = new EventEmitter<boolean>();

  languageSwitchOpen = false;

  constructor(@Inject(LOCALE_ID) public localeId: string, public router: Router) {}

  closeMenu(): void {
    this.burgerMenuToggle.emit(false);
  }

  openCookieMenu(): void {
    this.closeMenu();

    // TODO: Open cookie management popover
  }

  triggerLanguageSwitch(status: boolean) {
    this.languageSwitchOpen = status;
  }
}
